interface SearchableField {
  is_searchable: boolean;
  table_info: number;
}

export function getSearchableTableNames(
  fields: SearchableField[],
  tablesById: Record<number, { table_name: string }>,
  uiComponentsByTableName: Record<string, { search?: unknown }>,
): string[] {
  return Array.from(new Set(fields
    .filter(field => field.is_searchable)
    .map(field => tablesById[field.table_info]?.table_name)
    .filter((tableName): tableName is string => Boolean(
      tableName && !tableName.startsWith('_') && uiComponentsByTableName[tableName]?.search,
    ))));
}
